// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","headerIcon":"Header_headerIcon__kYf44"};